<template>
  <div id="contenedor-eliminar-licitacion">
    <v-card>
      <v-card-title class="secondary--text">
        Eliminar Licitación
      </v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¿Desea eliminar la licitación "{{licitacionEliminar.numero}}"?
        </span>
      </v-card-text>
        <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarLicitacion"
          :disabled="enviandoFormulario"
          :loading="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import mixLicitaciones from './mixLicitaciones';

export default {
  name: 'EliminarLicitacion',
  mixins: [mixLicitaciones],
  props: {
    licitacionEliminar: Object,
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
      this.mostrarDialogo = false;
    },
  },
};
</script>

<style>

</style>
